module.exports = __webpack_public_path__ + "img/male_avatar.cd5607d4.jpeg";